import flatpickr from 'flatpickr';
import { apiGet, APIURL, appendFlatpickrBaseStyles, cancelSelectEvent, changeSymbolForWidget, getCSSStyles, getHeaderPinButtonHTML, getHeaderPinStateClass, getNoDataHTML, getSymbolDropdown, getTraderSMCardHTML, getWidgetDataURI, initFlatpickrInShadow, isHeaderPinned, normalizeWidgetTheme, setupHeaderPin, toggleWidgetTheme, updateSelectedSymbolInDropdown } from './../../helpers';
import { FinancialConfig, WidgetEvent, WidgetEventHandler, WidgetEventType } from './../../types';
import { format } from 'date-fns';

export class TraderverseInsiderBuySellMomentumTimeline {
    private container: HTMLElement;
    private config: FinancialConfig;
    private eventHandlers: Map<WidgetEventType, WidgetEventHandler[]> = new Map();
    private updateInterval: number | null = null;
    private shadowRoot: ShadowRoot;
    private currentData: any = null;
    private widgetResizeObserver: ResizeObserver | null = null;
    private datePickerInstance: flatpickr.Instance | null = null;
    private filters: {
        startDate?: string | null;
        endDate?: string | null;
        symbol?: string;
        groupBy?: string;
        showAs?: string;
        movingAverageWindow?: number;
        minTransactionValue?: number;
    } = {};
    constructor(config: FinancialConfig) {
        this.config = { ...this.getDefaultConfig(), ...config };
        this.config.theme = normalizeWidgetTheme(this.config.theme);
        const today = new Date();
        const start = new Date();
        start.setDate(today.getDate() - 14);
        this.filters = {
            startDate: format(start, 'yyyy-MM-dd'),
            endDate: format(today, 'yyyy-MM-dd'),
            symbol: 'MSFT',
            groupBy: 'month',
            showAs: 'ratio',
            movingAverageWindow: 3,
            minTransactionValue: 500000
        };
        this.container = this.resolveContainer(config.container);

        if ((this.container as any).shadowRoot) {
            this.shadowRoot = (this.container as any).shadowRoot;
        } else {
            this.shadowRoot = this.container.attachShadow({ mode: 'closed' });
        }
        this.init();

        this.widgetResizeObserver = new ResizeObserver(() => {
            this.updateDisplay();
        });
        setTimeout(() => {
            const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
            if (widget) this.widgetResizeObserver?.observe(widget);
        }, 0);
    }



    private getDefaultConfig(): Partial<FinancialConfig> {
        return {
      headerPinned: true,
            type: "Cash and Debt",
            theme: 'default-dark',
            width: '100%',
            height: '400px',
            autosize: true,
            period: 'Yearly',
            interval: 'thisweek'
        } as any;
    }

    private resolveContainer(container: string | HTMLElement): HTMLElement {
        if (typeof container === 'string') {
            const el = document.getElementById(container) || document.querySelector(container);
            if (!el) throw new Error(`Container not found: ${container}`);
            return el as HTMLElement;
        }
        return container;
    }

    private async init(): Promise<void> {
        await this.createWidget();
    setupHeaderPin(this.shadowRoot, this.config);
        await this.injectChartLibrary();
        await this.setupChart(this.config.symbol!);
        this.emit('ready', {});
        cancelSelectEvent(this.shadowRoot);
        this.config.onReady?.();
    }

    private async createWidget(): Promise<void> {
        let themeClass = 'defaultDarkMode';
      let dataTheme = 'default-dark';
          let seasonalityWidgetIndex = 0;
    const widgetIndex = seasonalityWidgetIndex++;
      
      if (this.config.theme === 'white') {
        themeClass = 'whiteMode';
        dataTheme = 'white';
      } else if (this.config.theme === 'black') {
        themeClass = 'blackMode';
        dataTheme = 'black';
      } else if (this.config.theme === 'default-lite') {
  themeClass = 'defaultLightMode';
  dataTheme = 'default-lite';
}
        const widgetHtml = `
    <div style="width: ${typeof this.config.width == "number" ? this.config.width+ 'px' : this.config.width  };height: ${typeof this.config.height == "number" ? this.config.height+ 'px' : this.config.height};" class="widgetBox ${themeClass} loading ${getHeaderPinStateClass(this.config)}" data-testing-id="insider-buy-sell-momentum-${widgetIndex}" data-theme="${dataTheme}" data-theme="${this.config.theme}">
        <div class="headTop">
            <h4 class="title market">${this.getTitleIconSvg()}Insider Buy/Sell Momentum Timeline </h4>
            <div class="actionCol">${getHeaderPinButtonHTML(this.config)} <div class="item">
                <button class="filters-toggle" type="button"> <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.1794 0.950592H1.72077C1.57285 0.950469 1.42802 0.991908 1.30363 1.06995C1.17925 1.14799 1.08058 1.25932 1.01944 1.39061C0.958302 1.5219 0.937286 1.66759 0.958909 1.81023C0.980533 1.95286 1.04388 2.0864 1.14136 2.19484L5.22108 6.73834C5.34378 6.8752 5.41132 7.05084 5.41114 7.23259V10.8881C5.41114 10.9463 5.42504 11.0037 5.45175 11.0558C5.47846 11.1079 5.51725 11.1532 5.56503 11.1881L7.87343 12.8756C7.93059 12.9174 7.99856 12.9428 8.06972 12.9491C8.14088 12.9553 8.21242 12.9421 8.27633 12.911C8.34023 12.8799 8.39398 12.832 8.43154 12.7727C8.46911 12.7135 8.489 12.6452 8.489 12.5756V7.23259C8.48882 7.05084 8.55636 6.8752 8.67906 6.73834L12.7588 2.19409C13.1943 1.70959 12.8403 0.950592 12.1794 0.950592Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/> </svg> </button>
              </div> </div>
        </div>
        <div class="inBody">
            <div class="optionsRow">
                ${this.config.hideSymbol ? '<div class="item dropStyle01"></div>' : `<div class="item dropStyle01">
                <div class="trader-sm-card" id="selected-symbol">
                ${getTraderSMCardHTML(this.config.stock ?? { symbol: this.config.symbol!, type: "stock", name: "" })}
                </div>
                <span id="symbol-dropdown-placeholder"></span>
                </div>`}

                <span></span>
                
                <div class="filtersBox sideBar hidden">
                    <div class="item dateRange">
    <input type="text" class="date-input" />
                    <i><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M9.91667 1.16667H8.75V0.583333C8.75 0.428624 8.68854 0.280251 8.57915 0.170854C8.46975 0.0614581 8.32138 0 8.16667 0C8.01196 0 7.86358 0.0614581 7.75419 0.170854C7.64479 0.280251 7.58333 0.428624 7.58333 0.583333V1.16667H4.08333V0.583333C4.08333 0.428624 4.02188 0.280251 3.91248 0.170854C3.80308 0.0614581 3.65471 0 3.5 0C3.34529 0 3.19692 0.0614581 3.08752 0.170854C2.97813 0.280251 2.91667 0.428624 2.91667 0.583333V1.16667H1.75C1.28587 1.16667 0.840752 1.35104 0.512563 1.67923C0.184375 2.00742 0 2.45254 0 2.91667V9.91667C0 10.3808 0.184375 10.8259 0.512563 11.1541C0.840752 11.4823 1.28587 11.6667 1.75 11.6667H9.91667C10.3808 11.6667 10.8259 11.4823 11.1541 11.1541C11.4823 10.8259 11.6667 10.3808 11.6667 9.91667V2.91667C11.6667 2.45254 11.4823 2.00742 11.1541 1.67923C10.8259 1.35104 10.3808 1.16667 9.91667 1.16667ZM10.5 9.91667C10.5 10.0714 10.4385 10.2198 10.3291 10.3291C10.2198 10.4385 10.0714 10.5 9.91667 10.5H1.75C1.59529 10.5 1.44692 10.4385 1.33752 10.3291C1.22812 10.2198 1.16667 10.0714 1.16667 9.91667V5.83333H10.5V9.91667ZM10.5 4.66667H1.16667V2.91667C1.16667 2.76196 1.22812 2.61358 1.33752 2.50419C1.44692 2.39479 1.59529 2.33333 1.75 2.33333H2.91667V2.91667C2.91667 3.07138 2.97813 3.21975 3.08752 3.32915C3.19692 3.43854 3.34529 3.5 3.5 3.5C3.65471 3.5 3.80308 3.43854 3.91248 3.32915C4.02188 3.21975 4.08333 3.07138 4.08333 2.91667V2.33333H7.58333V2.91667C7.58333 3.07138 7.64479 3.21975 7.75419 3.32915C7.86358 3.43854 8.01196 3.5 8.16667 3.5C8.32138 3.5 8.46975 3.43854 8.57915 3.32915C8.68854 3.21975 8.75 3.07138 8.75 2.91667V2.33333H9.91667C10.0714 2.33333 10.2198 2.39479 10.3291 2.50419C10.4385 2.61358 10.5 2.76196 10.5 2.91667V4.66667Z" fill="#9F9FA2"/> </svg> </i>                        
                    </div>
                    <div class="item">
                        <label>Group By</label>
                        <select id="filterGroupBy">
                            <option value="day">Day</option>
                            <option value="week">Week</option>
                            <option value="month" selected>Month</option>
                            <option value="quarter" >Quarter</option>
                            <option value="year">Year</option>
                        </select>
                    </div>
                    <div class="item">
                        <label>Show As</label>
                        <select id="filterShowAs">
                            <option value="ratio" selected>Ratio</option>
                            <option value="absolute">Absolute</option>
                        </select>
                    </div>
                    <div class="item">
                        <label>Moving Average Window</label>
                        <input type="number" id="filterMovingAverage" aria-label="Moving Average Window" value="3" min="1" />
                    </div>
                    <div class="item">
                        <label>Min Transaction Value</label>
                        <input type="number" id="filterMinTransaction" aria-label="Min Transaction Value" value="500000" min="0" />
                    </div>
                </div>
            </div>
            <div class="chartDv">
                <div id="chartContainer" class="chart"></div>
            </div>
        </div>
    </div>
    `;
        this.shadowRoot.innerHTML = widgetHtml;
        await this.attachStyles();
        if (this.config.isSymbolSelectable && !this.config.hideSymbol) {
            const dropdown = getSymbolDropdown((data: any) => this.onSelectChange(data));
            const placeholder = this.shadowRoot.getElementById('symbol-dropdown-placeholder');
            if (placeholder && dropdown) {
                placeholder.replaceWith(dropdown);
            }
        }
        this.initDatePicker();

        setTimeout(() => {
            const symbolEl = this.shadowRoot.querySelector('#filterSymbol') as HTMLInputElement | null;
            const groupEl = this.shadowRoot.querySelector('#filterGroupBy') as HTMLSelectElement | null;
            const showEl = this.shadowRoot.querySelector('#filterShowAs') as HTMLSelectElement | null;
            const maEl = this.shadowRoot.querySelector('#filterMovingAverage') as HTMLInputElement | null;
            const minEl = this.shadowRoot.querySelector('#filterMinTransaction') as HTMLInputElement | null;

            if (symbolEl) symbolEl.addEventListener('change', () => { this.filters.symbol = symbolEl.value; this.setupChart(); });
            if (groupEl) groupEl.addEventListener('change', () => { this.filters.groupBy = groupEl.value; this.setupChart(); });
            if (showEl) showEl.addEventListener('change', () => { this.filters.showAs = showEl.value; this.setupChart(); });
            if (maEl) maEl.addEventListener('change', () => { this.filters.movingAverageWindow = parseInt(maEl.value || '3', 10); this.setupChart(); });
            if (minEl) minEl.addEventListener('change', () => { this.filters.minTransactionValue = parseInt(minEl.value || '500000', 10); this.setupChart(); });

            if (this.filters.startDate && this.filters.endDate) {
                const d = this.shadowRoot.querySelector('.date-input') as HTMLInputElement | null;
                if (d) d.value = `${this.filters.startDate} to ${this.filters.endDate}`;
            }
            if (groupEl) groupEl.value = this.filters.groupBy || 'month';
            if (showEl) showEl.value = this.filters.showAs || 'ratio';
            if (maEl && this.filters.movingAverageWindow) maEl.value = String(this.filters.movingAverageWindow);
            if (minEl && this.filters.minTransactionValue) minEl.value = String(this.filters.minTransactionValue);
            if (symbolEl) symbolEl.value = this.filters.symbol || 'MSFT';

            const toggleBtn = this.shadowRoot.querySelector('.filters-toggle') as HTMLElement | null;
            const filtersBox = this.shadowRoot.querySelector('.filtersBox') as HTMLElement | null;
            if (toggleBtn && filtersBox) {
                toggleBtn.addEventListener('click', () => {
                    filtersBox.classList.toggle('hidden');
                });
            }
        }, 0);
    }

    onSelectChange(stock: any) {
        this.changeSymbol(stock.symbol, stock);
    }

    private initDatePicker(): void {
        try {
            const input = this.shadowRoot.querySelector('.date-input') as HTMLInputElement | null;
            if (!input) return;

            if (this.datePickerInstance && this.datePickerInstance.destroy) {
                this.datePickerInstance.destroy();
                this.datePickerInstance = null;
            }

            const defaultDates: string[] = [];
            if (this.filters.startDate) defaultDates.push(this.filters.startDate);
            if (this.filters.endDate) defaultDates.push(this.filters.endDate as string);

            this.datePickerInstance = initFlatpickrInShadow(input, this.shadowRoot, {
                mode: 'range',
                dateFormat: 'Y-m-d',
                defaultDate: defaultDates.length ? defaultDates : undefined,
                onClose: (selectedDates: Date[]) => {
                    if (selectedDates.length === 2) {
                        const [start, end] = selectedDates;
                        const s = format(start, 'yyyy-MM-dd');
                        const e = format(end, 'yyyy-MM-dd');
                        this.filters.startDate = s;
                        this.filters.endDate = e;
                        input.value = `${s} to ${e}`;
                        this.setupChart();
                    } else if (selectedDates.length === 1) {
                        const s = format(selectedDates[0], 'yyyy-MM-dd');
                        this.filters.startDate = s;
                        this.filters.endDate = s;
                        input.value = s;
                        this.setupChart();
                    }
                }
            });
        } catch (err) {
            console.warn('Date picker init failed:', err);
        }
    }


    private async attachStyles(): Promise<void> {
        try {
            appendFlatpickrBaseStyles(this.shadowRoot);
            const styleEl = await getCSSStyles();
            this.shadowRoot.appendChild(styleEl);
        } catch (err) {
            console.error('Failed to load CSS file:', err);
        }
    }

    private async injectChartLibrary(): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            if ((window as any).echarts) return resolve(true);
            if (this.shadowRoot.querySelector('script[data-chart-lib]')) {
                const script = this.shadowRoot.querySelector('script[data-chart-lib]') as HTMLScriptElement;
                script.onload = () => resolve(true);
            } else {
                const script = document.createElement('script');
                script.src = 'https://cdn.jsdelivr.net/npm/echarts@5/dist/echarts.min.js';
                script.async = true;
                script.setAttribute('data-chart-lib', 'true');
                this.shadowRoot.appendChild(script);
                script.onload = () => resolve(true);
            }
        });
    }

    private async setupChart(symbol?: string): Promise<void> {
        try {
            const today = new Date();
            const fallbackStart = new Date();
            fallbackStart.setDate(today.getDate() - 14);
            const startDate = this.filters.startDate || format(fallbackStart, 'yyyy-MM-dd');
            const endDate = this.filters.endDate || format(today, 'yyyy-MM-dd');
            const chartSymbol = this.filters.symbol || symbol || 'MSFT';
            const groupBy = this.filters.groupBy || 'month';
            const showAs = this.filters.showAs || 'ratio';
            const movingAverageWindow = this.filters.movingAverageWindow || 3;
            const minTransactionValue = this.filters.minTransactionValue || 500000;

            const url = `${APIURL}/v1/discover/insider-momentum?start_date=${startDate}&end_date=${endDate}&symbol=${chartSymbol}&group_by=${groupBy}&show_as=${showAs}&moving_average_window=${movingAverageWindow}&min_transaction_value=${minTransactionValue}`;

            const res = await apiGet({
                method: 'GET',
                url,
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!res.ok) throw new Error(`API error: ${res.status}`);
            const json = await res.json();
            this.currentData = json.data.data; // store only `data` portion
            const widgetBox = this.shadowRoot.querySelector('.widgetBox');
            if (widgetBox) widgetBox.classList.remove('loading');

            this.updateDisplay();
            this.emit('dataUpdate', { symbol: this.config.symbol, data: this.currentData });
        } catch (err) {
            console.error("Error fetching chart data:", err);
        }
    }

    private updateDisplay(): void {
        if (!this.currentData || !(window as any).echarts) {
            setTimeout(() => this.updateDisplay(), 100);
            return;
        }
        this.renderChartByType(this.config.type!);
    }

    private renderChartByType(type: string): void {
        // const container = this.shadowRoot.querySelector('#cashDebtContainer');
        // if (!container) return;

        // const html = ` `;
        // container.innerHTML = html;
        this.drawChartByType();
    }

    private drawChartByType(): void {
        const echarts = (window as any).echarts;
        const container = this.shadowRoot.querySelector('#chartContainer') as HTMLDivElement;
        if (!container) return;

        const instance = echarts.getInstanceByDom(container);
        if (instance) echarts.dispose(instance);
        const widgetBox = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;


        const data = this.currentData;
        // if (!data || !Array.isArray(data) || data.length === 0) {
        //     container.innerHTML = getNoDataHTML();
        //     return;
        // }
        if (!data || !Array.isArray(data) || data.length === 0) {

    widgetBox?.removeAttribute('data-testing-id');

    container.innerHTML = getNoDataHTML();
    return;
}
        const xAxisData = data.map((item: any) => {
            const dt = new Date(item.time_period ?? item.date ?? '');
            if (Number.isNaN(dt.getTime())) return String(item.time_period ?? item.date ?? '');
            return dt.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
        });

        const acquisitionsRatio = data.map((item: any) => item.acquisitions_ratio ?? 0);
        const dispositionsRatio = data.map((item: any) => item.dispositions_ratio ?? 0);
        const acquisitionsMA = data.map((item: any) => item.acquisitions_ratio_ma ?? null);
        const dispositionsMA = data.map((item: any) => item.dispositions_ratio_ma ?? null);
        const ratioValues = [
            ...acquisitionsRatio,
            ...dispositionsRatio,
            ...acquisitionsMA.filter((v: any) => typeof v === 'number'),
            ...dispositionsMA.filter((v: any) => typeof v === 'number')
        ];
        const maxRatio = ratioValues.length ? Math.max(1, ...ratioValues) : 1;

        const textColor = getComputedStyle(widgetBox).getPropertyValue('--charts-text-color');
        const axisLineColor = getComputedStyle(widgetBox).getPropertyValue('--charts-axis-color');
        const splitLineColor = getComputedStyle(widgetBox).getPropertyValue('--charts-split-line-color');

        const option = {
            backgroundColor: 'transparent',
            tooltip: {
                trigger: 'axis',
                formatter: (params: any) => {
                    const rows = params.map((p: any) => {
                        const val = typeof p.value === 'number' ? `${(p.value * 100).toFixed(2)}%` : p.value;
                        return `${p.marker} ${p.seriesName}: ${val}`;
                    }).join('<br/>');
                    const axisLabel = params[0]?.axisValue ?? '';
                    return `<b>${axisLabel}</b><br/>${rows}`;
                }
            },
            legend: {
                data: ['Acquisitions Ratio', 'Dispositions Ratio', 'Acquisitions Ratio MA', 'Dispositions Ratio MA'],
                bottom: 0,
                itemWidth: 16,
                itemHeight: 16,
                padding: [0, 8, 0, 0],
                textStyle: { color: '#736D9D', fontSize: 12 }
            },
            grid: { left: 0, right: 0, top: 10, bottom: 30, containLabel: true },
            xAxis: {
                type: 'category',
                data: xAxisData,
                splitLine: { lineStyle: { color: splitLineColor } },
                axisLabel: { color: textColor, fontSize: 12 },
            },
            yAxis: {
                type: 'value',
                min: 0,
                max: maxRatio,
                axisLine: { lineStyle: { color: axisLineColor } },
                splitLine: { lineStyle: { color: splitLineColor } },
                axisLabel: { color: textColor, fontSize: 12 },
            },
            series: [
                {
                    name: 'Acquisitions Ratio',
                    type: 'bar',
                    data: acquisitionsRatio,
                    itemStyle: {
                        color: '#44CA6C',
                        borderRadius: [4, 4, 0, 0]
                    }
                },
                {
                    name: 'Dispositions Ratio',
                    type: 'bar',
                    data: dispositionsRatio,
                    itemStyle: {
                        color: '#EE3D2D',
                        borderRadius: [4, 4, 0, 0]
                    }
                },
                {
                    name: 'Acquisitions Ratio MA',
                    type: 'line',
                    data: acquisitionsMA,
                    smooth: true,
                    symbol: 'circle',
                    lineStyle: { color: '#2E8B57', width: 2, type: 'dashed' },
                    itemStyle: { color: '#2E8B57' },
                    connectNulls: true
                },
                {
                    name: 'Dispositions Ratio MA',
                    type: 'line',
                    data: dispositionsMA,
                    smooth: true,
                    symbol: 'circle',
                    lineStyle: { color: '#C0392B', width: 2, type: 'dashed' },
                    itemStyle: { color: '#C0392B' },
                    connectNulls: true
                }
            ]
        };

        const chart = echarts.init(container);
        chart.setOption(option);
    }


    private changeSymbol(stockId: string, stock: any = null): void {
        this.filters.symbol = stockId;
        changeSymbolForWidget(this.shadowRoot, this.config, stock, stockId, (stockId: any) => this.setupChart(stockId), (type: any, data: any) => this.emit(type, data));
    }

    public on(type: WidgetEventType, handler: WidgetEventHandler): void {
        if (!this.eventHandlers.has(type)) this.eventHandlers.set(type, []);
        this.eventHandlers.get(type)!.push(handler);
    }
    public off(type: WidgetEventType, handler: WidgetEventHandler): void {
        const list = this.eventHandlers.get(type);
        if (list) this.eventHandlers.set(type, list.filter(h => h !== handler));
    }
    public setSymbol(symbol: string): void {
        this.changeSymbol(symbol);
        const dropdown = this.shadowRoot.querySelector('.symbol-dropdown') as HTMLSelectElement;
        if (dropdown) dropdown.value = symbol;
    }
    public async getWidgetImage(): Promise<string> {
        const widget = this.shadowRoot.querySelector('.widgetBox') as HTMLElement;
        return await getWidgetDataURI(widget);
    }
  
    public setTheme(theme: 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite'): void {
      if (!this.shadowRoot) return;
    
      this.config.theme = toggleWidgetTheme(
        this.shadowRoot,
        theme
      ) as 'white' | 'black' | 'default-dark' | 'default-lite' | 'default-lite';
    
      this.updateDisplay();
    }
    public destroy(): void {
        if (this.updateInterval) { clearInterval(this.updateInterval); this.updateInterval = null; }
        if (this.widgetResizeObserver) { this.widgetResizeObserver.disconnect(); this.widgetResizeObserver = null; }
        this.eventHandlers.clear(); this.shadowRoot.innerHTML = '';
    }
    private emit(type: WidgetEventType, data: any): void {
        const handlers = this.eventHandlers.get(type);
        if (handlers) { const evt: WidgetEvent = { type, data }; handlers.forEach(h => h(evt)); }
    }
    private getTitleIconSvg(): string {
      return `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18.75 28.4375H11.25C4.4625 28.4375 1.5625 25.5375 1.5625 18.75V11.25C1.5625 4.4625 4.4625 1.5625 11.25 1.5625H18.75C25.5375 1.5625 28.4375 4.4625 28.4375 11.25V18.75C28.4375 25.5375 25.5375 28.4375 18.75 28.4375ZM11.25 3.4375C5.4875 3.4375 3.4375 5.4875 3.4375 11.25V18.75C3.4375 24.5125 5.4875 26.5625 11.25 26.5625H18.75C24.5125 26.5625 26.5625 24.5125 26.5625 18.75V11.25C26.5625 5.4875 24.5125 3.4375 18.75 3.4375H11.25Z" fill="currentColor"/> <path d="M9.16252 19.05C8.96252 19.05 8.76252 18.9875 8.58752 18.85C8.17502 18.5375 8.10002 17.95 8.41252 17.5375L11.3875 13.675C11.75 13.2125 12.2625 12.9125 12.85 12.8375C13.425 12.7625 14.0125 12.925 14.475 13.2875L16.7625 15.0875C16.85 15.1625 16.9375 15.1625 17 15.15C17.05 15.15 17.1375 15.125 17.2125 15.025L20.1 11.3C20.4125 10.8875 21.0125 10.8125 21.4125 11.1375C21.825 11.45 21.9 12.0375 21.575 12.45L18.6875 16.175C18.325 16.6375 17.8125 16.9375 17.225 17C16.6375 17.075 16.0625 16.9125 15.6 16.55L13.3125 14.75C13.225 14.675 13.125 14.675 13.075 14.6875C13.025 14.6875 12.9375 14.7125 12.8625 14.8125L9.88752 18.675C9.72502 18.925 9.45002 19.05 9.16252 19.05Z" fill="currentColor"/> </svg>`;
    }

}

declare global { interface Window { TraderverseInsiderBuySellMomentumTimeline: typeof TraderverseInsiderBuySellMomentumTimeline; } }
if (typeof window !== 'undefined') { window.TraderverseInsiderBuySellMomentumTimeline = TraderverseInsiderBuySellMomentumTimeline; }
